"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get // this function will generate the query for lookup column
    // or for  LTAR column and return the query builder
    // query result will be aggregated json array string in case of Myssql and Postgres
    // and string with separator in case of sqlite and mysql
    // this function is used for sorting and grouping of lookup/LTAR column at the moment
    default () {
        return generateLookupSelectQuery;
    },
    get getDisplayValueOfRefTable () {
        return getDisplayValueOfRefTable;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _formulaQueryBuilderv2 = /*#__PURE__*/ _interop_require_default(require("~/db/formulav2/formulaQueryBuilderv2"));
const _genRollupSelectv2 = /*#__PURE__*/ _interop_require_default(require("~/db/genRollupSelectv2"));
const _catchError = require("~/helpers/catchError");
const _dbHelpers = require("~/helpers/dbHelpers");
const _models = require("~/models");
const _utils = require("~/utils");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const LOOKUP_VAL_SEPARATOR = '___';
async function getDisplayValueOfRefTable(context, relationCol) {
    // Use the column's own base_id for getColOptions since the relation metadata
    // is stored in the column's base, not the related table's base (cross-base links)
    const colOpt = await relationCol.getColOptions(_extends({}, context, {
        base_id: relationCol.base_id
    }));
    const model = await colOpt.getRelatedTable(context);
    const modelContext = _extends({}, context, {
        base_id: model.base_id
    });
    const cols = await model.getColumns(modelContext);
    return cols.find((col)=>col.pv) || cols[0];
}
async function generateLookupSelectQuery({ column, baseModelSqlv2, alias, model: _model, getAlias = (0, _utils.getAliasGenerator)('__lk_slt_'), isAggregation = false }) {
    const knex = baseModelSqlv2.dbDriver;
    const context = baseModelSqlv2.context;
    const rootAlias = alias;
    {
        let selectQb;
        const alias = getAlias();
        let lookupColOpt;
        let isBtLookup = true;
        const applyCte = (_qb)=>{};
        if (column.uidt === _nocodbsdk.UITypes.Lookup) {
            lookupColOpt = await column.getColOptions(context);
        } else if (column.uidt !== _nocodbsdk.UITypes.LinkToAnotherRecord && column.uidt !== _nocodbsdk.UITypes.Links) {
            _catchError.NcError.get(context).badRequest('Invalid field type');
        }
        await column.getColOptions(context);
        let refContext;
        {
            const relationCol = lookupColOpt ? await lookupColOpt.getRelationColumn(context) : column;
            const relation = await relationCol.getColOptions(context);
            const isMMLike = (0, _nocodbsdk.isMMOrMMLike)(relationCol);
            const { parentContext, childContext, refContext: _refContext, mmContext } = await relation.getParentChildContext(context, relationCol);
            refContext = _refContext;
            let relationType = relation.type;
            if (relationType === _nocodbsdk.RelationTypes.ONE_TO_ONE) {
                var _relationCol_meta;
                relationType = ((_relationCol_meta = relationCol.meta) == null ? void 0 : _relationCol_meta.bt) ? _nocodbsdk.RelationTypes.BELONGS_TO : _nocodbsdk.RelationTypes.HAS_MANY;
            }
            if (relationType === _nocodbsdk.RelationTypes.BELONGS_TO && !isMMLike) {
                const childColumn = await relation.getChildColumn(context);
                const parentColumn = await relation.getParentColumn(context);
                const childModel = await childColumn.getModel(childContext);
                await childModel.getColumns(childContext);
                const parentModel = await parentColumn.getModel(parentContext);
                await parentModel.getColumns(parentContext);
                const childBaseModel = await _models.Model.getBaseModelSQL(childContext, {
                    model: childModel,
                    dbDriver: knex
                });
                const parentBaseModel = await _models.Model.getBaseModelSQL(parentContext, {
                    model: parentModel,
                    dbDriver: knex
                });
                selectQb = knex(knex.raw(`?? as ??`, [
                    parentBaseModel.getTnPath(parentModel.table_name),
                    alias
                ])).where(`${alias}.${parentColumn.column_name}`, knex.raw(`??`, [
                    `${rootAlias || childBaseModel.getTnPath(childModel.table_name)}.${childColumn.column_name}`
                ]));
            } else if (relationType === _nocodbsdk.RelationTypes.HAS_MANY && !isMMLike) {
                isBtLookup = false;
                const childColumn = await relation.getChildColumn(context);
                const parentColumn = await relation.getParentColumn(context);
                const childModel = await childColumn.getModel(childContext);
                await childModel.getColumns(childContext);
                const parentModel = await parentColumn.getModel(parentContext);
                await parentModel.getColumns(parentContext);
                const childBaseModel = await _models.Model.getBaseModelSQL(childContext, {
                    model: childModel,
                    dbDriver: knex
                });
                const parentBaseModel = await _models.Model.getBaseModelSQL(parentContext, {
                    model: parentModel,
                    dbDriver: knex
                });
                selectQb = knex(knex.raw(`?? as ??`, [
                    childBaseModel.getTnPath(childModel.table_name),
                    alias
                ])).where(`${alias}.${childColumn.column_name}`, knex.raw(`??`, [
                    `${rootAlias || parentBaseModel.getTnPath(parentModel.table_name)}.${parentColumn.column_name}`
                ]));
            } else if (relationType === _nocodbsdk.RelationTypes.MANY_TO_MANY || isMMLike) {
                isBtLookup = false;
                const childColumn = await relation.getChildColumn(context);
                const parentColumn = await relation.getParentColumn(context);
                const childModel = await childColumn.getModel(childContext);
                await childModel.getColumns(childContext);
                const parentModel = await parentColumn.getModel(parentContext);
                await parentModel.getColumns(parentContext);
                const childBaseModel = await _models.Model.getBaseModelSQL(childContext, {
                    model: childModel,
                    dbDriver: knex
                });
                const parentBaseModel = await _models.Model.getBaseModelSQL(parentContext, {
                    model: parentModel,
                    dbDriver: knex
                });
                selectQb = knex(knex.raw(`?? as ??`, [
                    parentBaseModel.getTnPath(parentModel.table_name),
                    alias
                ]));
                const mmTableAlias = getAlias();
                const mmModel = await relation.getMMModel(context);
                const mmChildCol = await relation.getMMChildColumn(context);
                const mmParentCol = await relation.getMMParentColumn(context);
                const associatedBaseModel = await _models.Model.getBaseModelSQL(mmContext, {
                    model: mmModel,
                    dbDriver: knex
                });
                selectQb.innerJoin(associatedBaseModel.getTnPath(mmModel.table_name, mmTableAlias), knex.ref(`${mmTableAlias}.${mmParentCol.column_name}`), '=', knex.ref(`${alias}.${parentColumn.column_name}`)).where(knex.ref(`${mmTableAlias}.${mmChildCol.column_name}`), '=', knex.ref(`${rootAlias || childBaseModel.getTnPath(childModel.table_name)}.${childColumn.column_name}`));
            }
        }
        let lookupColumn = lookupColOpt ? await lookupColOpt.getLookupColumn(refContext) : await getDisplayValueOfRefTable(refContext, column);
        // if lookup column is qr code or barcode extract the referencing column
        if ([
            _nocodbsdk.UITypes.QrCode,
            _nocodbsdk.UITypes.Barcode
        ].includes(lookupColumn.uidt)) {
            // For cross-base lookups, lookupColumn might belong to a different base than context
            const lookupColContext = lookupColumn.base_id ? _extends({}, context, {
                base_id: lookupColumn.base_id
            }) : context;
            lookupColumn = await lookupColumn.getColOptions(lookupColContext).then((barcode)=>barcode.getValueColumn(refContext));
        }
        {
            let prevAlias = alias;
            let context = refContext;
            while(lookupColumn.uidt === _nocodbsdk.UITypes.Lookup || lookupColumn.uidt === _nocodbsdk.UITypes.LinkToAnotherRecord){
                const nestedAlias = getAlias();
                let relationCol;
                let nestedLookupColOpt;
                if (lookupColumn.uidt === _nocodbsdk.UITypes.Lookup) {
                    nestedLookupColOpt = await lookupColumn.getColOptions(context);
                    relationCol = await nestedLookupColOpt.getRelationColumn(context);
                } else {
                    relationCol = lookupColumn;
                }
                const relation = await relationCol.getColOptions(context);
                let relationType = (0, _nocodbsdk.isMMOrMMLike)(relationCol) ? _nocodbsdk.RelationTypes.MANY_TO_MANY : relation.type;
                if (relationType === _nocodbsdk.RelationTypes.ONE_TO_ONE) {
                    var _relationCol_meta1;
                    relationType = ((_relationCol_meta1 = relationCol.meta) == null ? void 0 : _relationCol_meta1.bt) ? _nocodbsdk.RelationTypes.BELONGS_TO : _nocodbsdk.RelationTypes.HAS_MANY;
                }
                const { parentContext, childContext, refContext: nestedRefContext, mmContext } = await relation.getParentChildContext(context, relationCol);
                // if any of the relation in nested lookupColOpt is
                // not belongs to then throw error as we don't support
                if (relationType === _nocodbsdk.RelationTypes.BELONGS_TO) {
                    const childColumn = await relation.getChildColumn(context);
                    const parentColumn = await relation.getParentColumn(context);
                    const childModel = await childColumn.getModel(childContext);
                    await childModel.getColumns(childContext);
                    const parentModel = await parentColumn.getModel(parentContext);
                    await parentModel.getColumns(parentContext);
                    const parentBaseModel = await _models.Model.getBaseModelSQL(parentContext, {
                        model: parentModel,
                        dbDriver: knex
                    });
                    selectQb.join(knex.raw(`?? as ??`, [
                        parentBaseModel.getTnPath(parentModel.table_name),
                        nestedAlias
                    ]), `${nestedAlias}.${parentColumn.column_name}`, `${prevAlias}.${childColumn.column_name}`);
                } else if (relationType === _nocodbsdk.RelationTypes.HAS_MANY) {
                    isBtLookup = false;
                    const childColumn = await relation.getChildColumn(context);
                    const parentColumn = await relation.getParentColumn(context);
                    const childModel = await childColumn.getModel(childContext);
                    await childModel.getColumns(childContext);
                    const parentModel = await parentColumn.getModel(parentContext);
                    await parentModel.getColumns(parentContext);
                    const childBaseModel = await _models.Model.getBaseModelSQL(childContext, {
                        model: childModel,
                        dbDriver: knex
                    });
                    selectQb.join(knex.raw(`?? as ??`, [
                        childBaseModel.getTnPath(childModel.table_name),
                        nestedAlias
                    ]), `${nestedAlias}.${childColumn.column_name}`, `${prevAlias}.${parentColumn.column_name}`);
                } else if (relationType === _nocodbsdk.RelationTypes.MANY_TO_MANY) {
                    isBtLookup = false;
                    const childColumn = await relation.getChildColumn(context);
                    const parentColumn = await relation.getParentColumn(context);
                    const childModel = await childColumn.getModel(childContext);
                    await childModel.getColumns(childContext);
                    const parentModel = await parentColumn.getModel(parentContext);
                    await parentModel.getColumns(parentContext);
                    const childBaseModel = await _models.Model.getBaseModelSQL(childContext, {
                        model: childModel,
                        dbDriver: knex
                    });
                    const parentBaseModel = await _models.Model.getBaseModelSQL(parentContext, {
                        model: parentModel,
                        dbDriver: knex
                    });
                    const mmTableAlias = getAlias();
                    const mmModel = await relation.getMMModel(context);
                    const mmChildCol = await relation.getMMChildColumn(context);
                    const mmParentCol = await relation.getMMParentColumn(context);
                    const associatedBaseModel = await _models.Model.getBaseModelSQL(mmContext, {
                        model: mmModel,
                        dbDriver: knex
                    });
                    selectQb.innerJoin(associatedBaseModel.getTnPath(mmModel.table_name, mmTableAlias), knex.ref(`${mmTableAlias}.${mmChildCol.column_name}`), '=', knex.ref(`${prevAlias}.${childColumn.column_name}`)).innerJoin(knex.raw('?? as ??', [
                        parentBaseModel.getTnPath(parentModel.table_name),
                        nestedAlias
                    ]), knex.ref(`${mmTableAlias}.${mmParentCol.column_name}`), '=', knex.ref(`${nestedAlias}.${parentColumn.column_name}`)).where(knex.ref(`${mmTableAlias}.${mmChildCol.column_name}`), '=', knex.ref(`${alias || childBaseModel.getTnPath(childModel.table_name)}.${childColumn.column_name}`));
                }
                if (lookupColumn.uidt === _nocodbsdk.UITypes.Lookup) lookupColumn = await nestedLookupColOpt.getLookupColumn(nestedRefContext);
                else lookupColumn = await getDisplayValueOfRefTable(nestedRefContext, relationCol);
                prevAlias = nestedAlias;
                context = nestedRefContext;
            }
            {
                // get basemodel and model of lookup column
                const model = await lookupColumn.getModel(context);
                const baseModelSqlv2 = await _models.Model.getBaseModelSQL(context, {
                    model,
                    dbDriver: knex
                });
                switch(lookupColumn.uidt){
                    case _nocodbsdk.UITypes.Links:
                    case _nocodbsdk.UITypes.Rollup:
                        {
                            const builder = (await (0, _genRollupSelectv2.default)({
                                baseModelSqlv2,
                                knex,
                                columnOptions: await lookupColumn.getColOptions(context),
                                alias: prevAlias
                            })).builder;
                            selectQb.select({
                                [lookupColumn.id]: knex.raw(builder).wrap('(', ')')
                            });
                        }
                        break;
                    case _nocodbsdk.UITypes.Formula:
                        {
                            const builder = (await (0, _formulaQueryBuilderv2.default)({
                                baseModel: baseModelSqlv2,
                                tree: (await lookupColumn.getColOptions(context)).formula,
                                model,
                                column: lookupColumn,
                                aliasToColumn: await model.getAliasColMapping(context),
                                tableAlias: prevAlias
                            })).builder;
                            selectQb.select(knex.raw(`?? as ??`, [
                                builder,
                                (0, _dbHelpers.getAs)(lookupColumn)
                            ]));
                        }
                        break;
                    case _nocodbsdk.UITypes.DateTime:
                    case _nocodbsdk.UITypes.LastModifiedTime:
                    case _nocodbsdk.UITypes.CreatedTime:
                        {
                            await baseModelSqlv2.selectObject({
                                qb: selectQb,
                                columns: [
                                    lookupColumn
                                ],
                                alias: prevAlias
                            });
                        }
                        break;
                    case _nocodbsdk.UITypes.Attachment:
                        if (!isAggregation) {
                            _catchError.NcError.get(context).badRequest('Group by using attachment column is not supported');
                            break;
                        }
                    // eslint-disable-next-line no-fallthrough
                    default:
                        {
                            selectQb.select(`${prevAlias}.${lookupColumn.column_name} as ${lookupColumn.id}`);
                        }
                        break;
                }
            }
            // if all relation are belongs to then we don't need to do the aggregation
            if (isBtLookup) {
                return {
                    builder: selectQb,
                    applyCte
                };
            }
            const subQueryAlias = getAlias();
            if (baseModelSqlv2.isPg) {
                // alternate approach with array_agg
                return {
                    builder: knex.select(knex.raw('json_agg(??)::text', [
                        lookupColumn.id
                    ])).from(selectQb.as(subQueryAlias)),
                    applyCte
                };
            /*
        // alternate approach with array_agg
        return {
          builder: knex
            .select(knex.raw('array_agg(??)', [lookupColumn.id]))
            .from(selectQb),
        };*/ // alternate approach with string aggregation
            // return {
            //   builder: knex
            //     .select(
            //       knex.raw('STRING_AGG(??::text, ?)', [
            //         lookupColumn.id,
            //         LOOKUP_VAL_SEPARATOR,
            //       ]),
            //     )
            //     .from(selectQb.as(subQueryAlias)),
            // };
            } else if (baseModelSqlv2.isMySQL) {
                return {
                    builder: knex.select(knex.raw('cast(JSON_ARRAYAGG(??) as NCHAR)', [
                        lookupColumn.id
                    ])).from(selectQb.as(subQueryAlias)),
                    applyCte
                };
            // return {
            //   builder: knex
            //     .select(
            //       knex.raw('GROUP_CONCAT(?? ORDER BY ?? ASC SEPARATOR ?)', [
            //         lookupColumn.id,
            //         lookupColumn.id,
            //         LOOKUP_VAL_SEPARATOR,
            //       ]),
            //     )
            //     .from(selectQb.as(subQueryAlias)),
            // };
            } else if (baseModelSqlv2.isSqlite) {
                // ref: https://stackoverflow.com/questions/13382856/sqlite3-join-group-concat-using-distinct-with-custom-separator
                // selectQb.orderBy(`${lookupColumn.id}`, 'asc');
                return {
                    builder: knex.select(knex.raw(`group_concat(??, ?)`, [
                        lookupColumn.id,
                        LOOKUP_VAL_SEPARATOR
                    ])).from(selectQb.as(subQueryAlias)),
                    applyCte
                };
            }
            _catchError.NcError.get(context).notImplemented('This operation on Lookup/LTAR for this database');
        }
    }
}
